export default __webpack_public_path__ + "static/media/panel-bkg-medium-2x.51ef0be9.png";